import React from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Button,
  AppTopNavi,
  Menu,
  MenuItem,
  WithTooltip,
  Icon,
  Tooltip,
  Popup,
  Input,
  WithPopup,
  Dialog,
} from "@abb/abb-common-ux-react";
import {
  ABB_STOP,
  ABB_PLAY,
  ABB_PAUSE,
  ABB_REFRESH,
  ABB_CLOSE,
  ABB_CHECK_MARK,
} from "../../utilities/IconConstants";
import { Status } from "../../models/sample/Status";
import * as CONSTANTS from "../../utilities/Constants";
import * as ICONCONSTANTS from "../../utilities/IconConstants";
import { Translation } from "react-i18next";
import History from "../../utilities/History";
import triggerNotifications from "../../utilities/TriggerNotifications";
import actionHeaderEditStore from "../../flux/stores/shared/ActionHeaderEditStore";
import IActionHeaderFormData, {
  IActionHeaderEditData,
} from "../../models/shared/ActionHeaderData";
import actionHeaderCommonStore from "../../flux/stores/shared/ActionHeaderCommonStore";
import propertyActions from "../../flux/actions/PropertyActions";
import gradeActions from "../../flux/actions/GradeActions";
import instrumentActions from "../../flux/actions/InstrumentActions";
import testplanActions from "../../flux/actions/TestplanActions";
import sourceActions from "../../flux/actions/SourceActions";
import productActions from "../../flux/actions/ProductActions";
import instrumentTypeActions from "../../flux/actions/InstrumentTypeActions";
import stationActions from "../../flux/actions/StationActions";
import instrumentDisableStore from "../../flux/stores/instrument/DisableStore";
import instrumentEnableStore from "../../flux/stores/instrument/EnableStore";
import testPlanEnableStore from "../../flux/stores/testplan/EnableStore";
import testPlanDisableStore from "../../flux/stores/testplan/DisableStore";
import gradeEnableStore from "../../flux/stores/grade/EnableStore";
import gradeDisableStore from "../../flux/stores/grade/DisableStore";
import productEnableStore from "../../flux/stores/product/EnableStore";
import productDisableStore from "../../flux/stores/product/DisableStore";
import Authorize from "../../utilities/Authorize";
import authUtility from '../../utilities/AuthUtility';
import userActions from "../../flux/actions/UserActions";
import scannerActions from "../../flux/actions/ScannerAction"
import i18next from "i18next";
import ReactToPrint from "react-to-print";

interface INameHeader {
  authKey?: string;
  data: string;
  startMeasure?: () => boolean;
  isMeasure?: boolean;
  measurementStatus?: boolean;
  measurementStop?: () => void;
  measurementPause?: () => void;
  measurementState?: string;
  stopMeasurement?: boolean;
  reMeasure?: () => void;
  isPaused?: boolean;
  resumeMeasurement?: () => void;

  measurementReject?: () => void;
  measurementApprove?: () => void;
  isComplete?: boolean;
  completeMeasurement?: () => void;

  onGradeActivate?: () => void;
  onProductActivate?: () => void;
  isShowProductPopup?: boolean;
  isShowGradePopup?: boolean;
  isShowMore?: boolean;
  onMoreClick?: () => void;
  setGradeName?: (val: string) => void;
  gradeName?: any;
  setProductName?: (val: string) => void;
  productName?: any;
  onCreateGrade?: (e: any, val: boolean) => void;
  onCreateProduct?: (e: any, val: boolean) => void;
  setCode?: (val: string) => void;
  inputCode?: any;
  onCloseGrade?: () => void;
  onCloseProduct?: () => void;
  gradeNameError?: boolean;
  productNameError?: boolean;
  codeError?: boolean;
  isButtonDisabled?: boolean;
  onCreateBackup?: () => void;
  isShowBackup?: boolean;
  isSampleValidToMeaure?: boolean | false;
  isCreatingBackup?: boolean;

  startInstrumentTest?: boolean;
  onStartInstrumentTest?: () => void;
  showRefresh?: boolean;
  onRefresh?: () => void;
  isEnable?: boolean;
  isEnabeDisableButton?: boolean;
  isDelete?: boolean;
  isMoreEnable?: boolean;
  disableEdit?: boolean;
  disableDelete?: boolean;
  disableEditOrDelete?: boolean;
  showPrint?: boolean;
  onPrintClick?: () => void;
  onAfterPrint?: () => void; 
  componentRef?: any;
  printRef?: any;
  printLoading?: boolean;
}

export default class NameHeader extends React.Component<
  INameHeader,
  {
    clicked: boolean;
    isEditShow: boolean;
    toastMsg: string;
    showToast: boolean;
    deleteModalVisible: boolean;
    editData: any;
    moduleName: string;
    deleteTitle: string;
    deleteId: string;
    isEnableViewAll: boolean;
    deleteRequesId: string;
    deleteMessage: string;
    isEnableReport: boolean;
    isSampleWithScanner: boolean;
    exportId: any;
  }
> {
  private _mount: boolean = false;
  _messages: [];
  constructor(props: INameHeader) {
    super(props);
    this._mount = true;
    this.state = {
      clicked: false,
      isEditShow: false,
      toastMsg: "",
      showToast: false,
      deleteModalVisible: false,
      editData: {},
      moduleName: "",
      deleteTitle: "",
      deleteId: "",
      isEnableViewAll: false,
      deleteRequesId: "",
      deleteMessage: "",
      isEnableReport: false,
      isSampleWithScanner: false,
      exportId: "",
    };
  }
  static defaultProps = {
    gradeNameError: false,
    productNameError: false,
    codeError: false,
  };
  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    actionHeaderCommonStore.on(
      CONSTANTS.CHANGE_EVENT,
      (state: IActionHeaderFormData) => {
        if (this._mount) {
          this.setState({
            moduleName: state.moduleName,
          });
        }
      }
    );

    actionHeaderEditStore.on(
      CONSTANTS.CHANGE_EVENT,
      (state: IActionHeaderEditData) => {
        if (this._mount) {
          this.setState({
            moduleName: state.moduleName,
            editData: state.editData,
            deleteTitle: state.deleteTitle,
            deleteId: state.deleteId,
            isEnableViewAll: state.isEnableViewAll || false,
            exportId: state.exportId,
            deleteRequesId: state.deleteRequestId,
            deleteMessage: state.deleteMessage,
            isEnableReport: state.isEnableReport,
            isSampleWithScanner: false,
          });
        }
      }
    );

    // Instrument
    instrumentDisableStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._messages = state.messages;
    });
    instrumentEnableStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._messages = state.messages;
    });

    // Test Plan
    testPlanEnableStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._messages = state.messages;
    });
    testPlanDisableStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._messages = state.messages;
    });

    // Grade
    gradeEnableStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._messages = state.messages;
    });
    gradeDisableStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._messages = state.messages;
    });

    // Product
    productEnableStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._messages = state.messages;
    });
    productDisableStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._messages = state.messages;
    });
  }

  private openDialog = () => {
    this.setState({ deleteModalVisible: true });
  };

  onClickedMeasure() {
    if (this.props.startMeasure()) {
      this.setState({ clicked: true });
    } else {
      this.setState({ clicked: false });
    }
  }

  private onEditCall = () => {
    this.setState({
      isEditShow: !this.state.isEditShow,
    });
  };

  private onEditClick = () => {
    if (this.state.moduleName === CONSTANTS.MODULE_STATION) {
      History.push(CONSTANTS.STATION_CREATE_URL, this.state.editData);
    }
    if (this.state.moduleName === CONSTANTS.MODULE_PRODUCT) {
      History.push(CONSTANTS.PRODUCT_CREATE_URL, this.state.editData);
    }
    if (this.state.moduleName === CONSTANTS.MODULE_GRADE) {
      History.push(CONSTANTS.GRADE_CREATE_URL, this.state.editData);
    }
    if (this.state.moduleName === CONSTANTS.MODULE_TESTPLAN) {
      History.push(CONSTANTS.TESTPLAN_CREATE_URL, this.state.editData);
    }
    if (this.state.moduleName === CONSTANTS.MODULE_INSTRUMENT) {
      History.push(CONSTANTS.INSTRUMENT_CREATE_URL, this.state.editData);
    }
    if (this.state.moduleName === CONSTANTS.MODULE_SOURCE) {
      History.push(CONSTANTS.SOURCE_CREATE_URL, this.state.editData);
    }
    if (this.state.moduleName === CONSTANTS.MODULE_PROPERTY) {
      History.push(CONSTANTS.PROPERTY_CREATE_URL, this.state.editData);
    }
    if (this.state.moduleName === CONSTANTS.MODULE_INSTRUMENTTYPE) {
      History.push(CONSTANTS.INSTRUMENTTYPE_CREATE_URL, this.state.editData);
    }
    if (this.state.moduleName === CONSTANTS.MODULE_SCANNER) {
      History.push(CONSTANTS.SCANNER_CREATE_URL, this.state.editData);
    }
    if (this.state.moduleName === CONSTANTS.MODULE_USERS) {
      History.push(CONSTANTS.USER_CREATE_URL, this.state.editData);
    }
    if (this.state.moduleName === CONSTANTS.MODULE_ROLES_AND_PERMISSIONS) {
      History.push(CONSTANTS.ROLESANDPERMISSIONS_CREATE_URL, this.state.editData);
    }
  };
  private onDeleteClick = () => {
    const ids: any = [];
      ids.push(this.state.deleteId);

    if (this.state.moduleName === CONSTANTS.MODULE_PRODUCT) {
      productActions
        .deleteMultiple(ids, this.state.deleteRequesId)
        .then(() => {
          triggerNotifications.success([
            `${this.props.data || ""} ${i18next.t("Product is deleted.")}`,
          ]);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data);
        });
    } else if (this.state.moduleName === CONSTANTS.MODULE_GRADE) {
      gradeActions
        .deleteMultiple(ids, this.state.deleteRequesId)
        .then(() => {
          triggerNotifications.success([
            `${this.props.data || ""} ${i18next.t("Grade is deleted.")}`,
          ]);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data);
        });
    } else if (this.state.moduleName === CONSTANTS.MODULE_TESTPLAN) {
      testplanActions
        .deleteMultiple(ids, this.state.deleteRequesId)
        .then(() => {
          triggerNotifications.success([
            `${this.props.data || ""} ${i18next.t("Test plan is deleted.")}`,
          ]);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data);
        });
    } else if (this.state.moduleName === CONSTANTS.MODULE_INSTRUMENT) {
      instrumentActions
        .deleteMultiple(ids, this.state.deleteRequesId)
        .then(() => {
          triggerNotifications.success([
            `${this.props.data || ""} ${i18next.t("Instrument is deleted.")}`,
          ]);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data);
        });
    } else if (this.state.moduleName === CONSTANTS.MODULE_SOURCE) {
      sourceActions
        .delete(this.state.deleteId, this.state.deleteRequesId)
        .then(() => {
          triggerNotifications.success([
            `${this.props.data || ""} ${i18next.t("Source is deleted.")}`,
          ]);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data);
        });
    } else if (this.state.moduleName === CONSTANTS.MODULE_PROPERTY) {
      propertyActions
        .delete(this.state.deleteId, this.state.deleteRequesId)
        .then(() => {
          triggerNotifications.success([
            `${this.props.data || ""} ${i18next.t("Property is deleted.")}`,
          ]);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data);
        });
    } else if (this.state.moduleName === CONSTANTS.MODULE_INSTRUMENTTYPE) {
      instrumentTypeActions
        .delete(this.state.deleteId, this.state.deleteRequesId)
        .then(() => {
          triggerNotifications.success([
            `${this.props.data || ""} ${i18next.t("Instrument type is deleted.")}`,
          ]);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data);
        });
    } else if (this.state.moduleName === CONSTANTS.MODULE_STATION) {
      stationActions
        .delete(this.state.deleteId, this.state.deleteRequesId)
        .then(() => {
          triggerNotifications.success([
            `${this.props.data || ""} ${i18next.t("Instrument station is deleted.")}`,
          ]);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data);
        });
    } else if (this.state.moduleName === CONSTANTS.MODULE_USERS) {
      userActions
        .delete(this.state.deleteId, this.state.deleteRequesId)
        .then(() => {
          triggerNotifications.success([
            `${this.props.data || ""} ${i18next.t("User is deleted.")}`,
          ]);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data);
        });
    } else if (this.state.moduleName === CONSTANTS.MODULE_SCANNER) {
      scannerActions
        .delete(this.state.deleteId, this.state.deleteRequesId)
        .then(() => {
          triggerNotifications.success([
            `${this.props.data || ""} ${i18next.t("Scanner is deleted.")}`,
          ]);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data);
        });
    }
    this.setState({ deleteModalVisible: false });
  };

  private onDisableClick = () => {
    if (this.state.moduleName === CONSTANTS.MODULE_INSTRUMENT) {
      instrumentActions
        .disable(this.state.deleteId, uuidv4())
        .then(() => {
          triggerNotifications.success(this._messages);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data);
        });
    } else if (this.state.moduleName === CONSTANTS.MODULE_TESTPLAN) {
      testplanActions
        .disable(this.state.deleteId, uuidv4())
        .then(() => {
          triggerNotifications.success(this._messages);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data);
        });
    } else if (this.state.moduleName === CONSTANTS.MODULE_GRADE) {
      gradeActions
        .disable(this.state.deleteId, uuidv4())
        .then(() => {
          triggerNotifications.success(this._messages);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data);
        });
    } else if (this.state.moduleName === CONSTANTS.MODULE_PRODUCT) {
      productActions
        .disable(this.state.deleteId, uuidv4())
        .then(() => {
          triggerNotifications.success(this._messages);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data);
        });
    }
  };

  private onEnableClick = () => {
    if (this.state.moduleName === CONSTANTS.MODULE_INSTRUMENT) {
      instrumentActions
        .enable(this.state.deleteId, uuidv4())
        .then(() => {
          triggerNotifications.success(this._messages);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data);
        });
    } else if (this.state.moduleName === CONSTANTS.MODULE_TESTPLAN) {
      testplanActions
        .enable(this.state.deleteId, uuidv4())
        .then(() => {
          triggerNotifications.success(this._messages);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data);
        });
    } else if (this.state.moduleName === CONSTANTS.MODULE_GRADE) {
      gradeActions
        .enable(this.state.deleteId, uuidv4())
        .then(() => {
          triggerNotifications.success(this._messages);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data);
        });
    } else if (this.state.moduleName === CONSTANTS.MODULE_PRODUCT) {
      productActions
        .enable(this.state.deleteId, uuidv4())
        .then(() => {
          triggerNotifications.success(this._messages);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data);
        });
    }
  };

  public render() {
    return (
      <Translation>
        {(t) => (
          <div
            className="pageheader  pl-3 pr-1"
            style={{
              marginLeft:
                this.state.moduleName === CONSTANTS.MODULE_SETTINGS
                  ? "20px"
                  : "0px",
            }}
          >
            <div className="name-header-font float-left name-overflow" style={{ maxWidth: this.props.data && this.props.data.length > 20 ? '18vw' : 'auto' }}>
              {t(this.props.data)}
            </div>
            {!this.props.isMoreEnable ? (
              <ol className="navbar-nav mr-auto d-block float-right">
                <li className="nav-item">
                  <WithTooltip>
                    <Button
                      sizeClass="medium"
                      type="discreet-black"
                      shape={"pill"}
                      icon={"abb/menu-narrow"}
                      onClick={this.onEditCall}
                      className="btn-40 options-draw "
                    />
                    <Tooltip className="nav-tooltip">
                      <p>{t(CONSTANTS.MORE)}</p>
                    </Tooltip>
                  </WithTooltip>
                  {this.state.isEditShow && (
                    <div
                      className="ul-class "
                      style={{
                        marginLeft: -20,
                      }}
                    >
                      {this.props.isEnabeDisableButton ? (
                        <Menu onLostFocus={this.onEditCall}>
                          <MenuItem
                            disabled={!authUtility.hasPermission([`${this.props.authKey}:Edit`])}
                            text={t(CONSTANTS.EDIT)}
                            onSelect={this.onEditClick}
                          />
                          <MenuItem
                            disabled={!authUtility.hasPermission([`${this.props.authKey}:Delete`])}
                            text={t(CONSTANTS.DELETE)}
                            onSelect={this.openDialog}
                          />
                          {this.props.isEnable ? (
                            <MenuItem
                              disabled={!authUtility.hasPermission([`${this.props.authKey}:Disable`])}
                              text={t(CONSTANTS.DISABLE)}
                              onSelect={this.onDisableClick}
                            />
                          ) : (
                            <MenuItem
                              disabled={!authUtility.hasPermission([`${this.props.authKey}:Enable`])}
                              text={t(CONSTANTS.ENABLE)}
                              onSelect={this.onEnableClick}
                            />
                          )}
                        </Menu>
                      ) : (<>
                        {
                          this.props.disableEditOrDelete ?
                            (
                              <Menu onLostFocus={this.onEditCall}>
                                <MenuItem
                                  disabled={(!authUtility.hasPermission([`${this.props.authKey}:Edit`]) || this.props?.disableEdit) ?? false}
                                  text={t(CONSTANTS.EDIT)}
                                  onSelect={this.onEditClick}
                                />
                                <MenuItem
                                  disabled={(!authUtility.hasPermission([`${this.props.authKey}:Delete`]) || this.props?.disableDelete) ?? false}
                                  text={t(CONSTANTS.DELETE)}
                                  onSelect={this.openDialog}
                                />
                              </Menu>
                            ) : (
                              <Menu onLostFocus={this.onEditCall}>
                                <MenuItem
                                  disabled={(!authUtility.hasPermission([`${this.props.authKey}:Edit`]) || this.props?.isDelete) ?? false}
                                  text={t(CONSTANTS.EDIT)}
                                  onSelect={this.onEditClick}
                                />
                                <MenuItem
                                  disabled={(!authUtility.hasPermission([`${this.props.authKey}:Delete`]) || this.props?.isDelete) ?? false}
                                  text={t(CONSTANTS.DELETE)}
                                  onSelect={this.openDialog}
                                />
                              </Menu>
                            )
                        }</>
                      )}
                    </div>
                  )}
                </li>
              </ol>
            ) : (
              <></>
            )}
            {this.props.startInstrumentTest && (
              <Authorize scopes={[`${CONSTANTS.AUTHKEY_INSTRUMENT_MODE}:StartTest`]}>
                <div className="float-right mt-0  btn-align-center">
                  <Button
                    icon={ABB_PLAY}
                    type="primary-black"
                    shape="pill"
                    onClick={() => this.props.onStartInstrumentTest()}
                    text={t("Start Test")}
                  />
                </div>
              </Authorize>
            )}
            {this.props.showRefresh && (
              <>
                <Authorize scopes={[`${this.props.authKey}:Refresh`]}>
                  <div className="float-right mt-0  btn-align-center">
                    <Button
                      type="primary-black"
                      shape="pill"
                      icon={ABB_REFRESH}
                      text={t(CONSTANTS.BUTTON_REFRESH)}
                      onClick={this.props.onRefresh}
                    />
                  </div>
                </Authorize>
                {this.props.showPrint && (
                    <div className="float-right mt-0  btn-align-center" style={{marginRight: "10px"}}>
                      <ReactToPrint
                        onBeforeGetContent={this.props.onPrintClick}
                        onAfterPrint={this.props.onAfterPrint}
                        // tslint:disable-next-line: jsx-no-lambda
                        trigger={() => (
                          <Button
                            icon="abb/print"
                            text={t("Print")}
                            type="primary-black"
                            shape="pill"
                            isLoading={this.props.printLoading}
                          />
                        )}
                        // tslint:disable-next-line: jsx-no-lambda
                        content={() => this.props.printRef}
                      />
                    </div>
                )}</>
            )}
            {this.props.isMeasure ? (
              <div className="float-right mt-0  btn-align-center">
                {this.props.measurementState === Status.NOTMEASURED ||
                  this.props.measurementState === Status.STOPPED ? (
                  <Button
                    icon={ABB_PLAY}
                    type="primary-blue"
                    onClick={() => this.onClickedMeasure()}
                    disabled={
                      this.state.clicked || !this.props.isSampleValidToMeaure
                    }
                    text={t(CONSTANTS.BUTTON_MEASURE)}
                  />
                ) : null}
              </div>
            ) : null}

            {this.props.isMeasure ? (
              <div className="float-right mt-0">
                {this.props.measurementState === Status.APPROVED ? (
                  <p
                    className="font-weight-bold mt-2 mr-3"
                    style={{ color: "green" }}
                  >
                    {t(this.props.measurementState)}
                  </p>
                ) : this.props.measurementState === Status.REJECTED ? (
                  <p
                    className="font-weight-bold mt-2 mr-3"
                    style={{ color: "red" }}
                  >
                    {t(this.props.measurementState)}
                  </p>
                ) : null}
              </div>
            ) : null}

            {this.props.measurementStatus ? (
              <div className="float-right btn-align-center">
                <Button
                  icon={ABB_STOP}
                  type="discreet-blue"
                  className="stop-color"
                  onClick={() => this.props.measurementStop()}
                  text={t(CONSTANTS.BUTTON_STOP)}
                />
                <Button
                  icon={ABB_PAUSE}
                  className="ml-2"
                  type="discreet-blue"
                  onClick={() => this.props.measurementPause()}
                  text={t(CONSTANTS.BUTTON_PAUSE)}
                />
              </div>
            ) : null}

            {this.props.isPaused ? (
              <div className="float-right btn-align-center">
                <Button
                  icon={ABB_STOP}
                  type="discreet-blue"
                  className="stop-color"
                  onClick={() => this.props.measurementStop()}
                  text={t(CONSTANTS.BUTTON_STOP)}
                />

                <Button
                  className="ml-2"
                  icon={ABB_PLAY}
                  type="primary-blue"
                  onClick={() => this.props.resumeMeasurement()}
                  text={t(CONSTANTS.BUTTON_RESUME)}
                />
              </div>
            ) : null}

            {this.props.stopMeasurement ? (
              <div className="float-right btn-align-center">
                <Button
                  icon={ABB_REFRESH}
                  type="discreet-blue"
                  onClick={() => this.props.reMeasure()}
                  text={t(CONSTANTS.BUTTON_REMEASURE)}
                />

                <Button
                  className="ml-2"
                  icon={ABB_CHECK_MARK}
                  type="primary-blue"
                  onClick={() => this.props.completeMeasurement()}
                  text={t(CONSTANTS.BUTTON_COMPLETE)}
                />
              </div>
            ) : null}
            {this.props.isComplete && (
              <div className="float-right btn-align-center">
                <Authorize scopes={[`${this.props.authKey}:Reject`]}>
                  <Button
                    icon={ABB_CLOSE}
                    type="discreet-blue"
                    className="stop-color"
                    onClick={() => this.props.measurementReject()}
                    text={t(CONSTANTS.BUTTON_REJECT)}
                  />
                </Authorize>
                <Authorize scopes={[`${this.props.authKey}:Approve`]}>
                  <Button
                    icon={ABB_CHECK_MARK}
                    className="ml-2"
                    type="primary-blue"
                    onClick={() => this.props.measurementApprove()}
                    text={t(CONSTANTS.BUTTON_APPROVE)}
                  />
                </Authorize>
                <span className="ml-4">
                  <WithTooltip>
                    <Icon
                      name={ICONCONSTANTS.ABB_MENU_NARROW}
                      sizeClass="small"
                      color="##1F1F1F"
                      style={{ cursor: "pointer" }}
                      onClick={() => this.props.onMoreClick()}
                    />
                    <Tooltip className="pl-2 pr-2 pb-1 nav-tooltip">
                      <p>{t(CONSTANTS.MORE)}</p>
                    </Tooltip>
                  </WithTooltip>
                </span>
                {this.props.isShowMore ? (
                  <div
                    className="ul-class "
                    style={{ marginLeft: "132px" }}
                  >
                    <Menu
                    >
                      <MenuItem
                        text={
                          t(CONSTANTS.CREATE) + " " + t(CONSTANTS.MENU_GRADE)
                        }
                        onSelect={() => this.props.onGradeActivate()}
                      />
                      <MenuItem
                        text={
                          t(CONSTANTS.CREATE) + " " + t(CONSTANTS.MENU_PRODUCT)
                        }
                        onSelect={() => this.props.onProductActivate()}
                      />
                    </Menu>
                  </div>
                ) : null}

                <div className="popup-shift">
                  {this.props.isShowGradePopup ? (
                    <WithPopup>
                      <div></div>
                      <Popup
                        trigger="controlled"
                        position="bottom center"
                        disableDefaultStyle={true}
                        showCloseButton={true}
                        show={this.props.isShowGradePopup}
                        defaultOpen={false}
                        closeOnLostFocus={true}
                        onClose={() => this.props.onCloseGrade()}
                      >
                        <p>
                          <Input
                            inputAttributes={{ autoFocus: "true" }}
                            className={
                              this.props.gradeNameError
                                ? "error-code mt-2"
                                : "mt-2"
                            }
                            dataType="text"
                            maxLength={250}
                            label={t(
                              CONSTANTS.MODULE_GRADE +
                              " " +
                              CONSTANTS.LABLE_NAME
                            )}
                            placeholder={t(CONSTANTS.LABLE_NAME)}
                            required={true}
                            value={String(this.props.gradeName)}
                            onValueChange={(val: string) =>
                              this.props.setGradeName(val)
                            }
                            showValidationBarWhenInvalid={
                              this.props.gradeNameError
                            }
                            description={
                              this.props.gradeNameError &&
                              t(CONSTANTS.INSTRUMENT_NAME_VALIDATION_ERROR)
                            }
                          />
                        </p>
                        <p>
                          <Input
                            className={
                              this.props.codeError ? "error-code mt-2" : "mt-2"
                            }
                            dataType="text"
                            maxLength={20}
                            label={t(CONSTANTS.LABEL_CODEID)}
                            placeholder={t(CONSTANTS.LABEL_CODEID)}
                            required={true}
                            value={String(this.props.inputCode)}
                            onValueChange={(val: string) =>
                              this.props.setCode(val)
                            }
                            showValidationBarWhenInvalid={this.props.codeError}
                            description={
                              this.props.codeError &&
                              t(CONSTANTS.INSTRUMENT_CODE_VALIDATION_ERROR)
                            }
                          />
                        </p>
                        <p>
                          <Button
                            disabled={this.props.isButtonDisabled}
                            type="primary-blue"
                            shape="rounded"
                            text={t(CONSTANTS.BUTTON_CREATE)}
                            icon={ICONCONSTANTS.ABB_PLUS}
                            className={
                              this.props.isButtonDisabled
                                ? "border ml-4 mt-2 w-75"
                                : "border border-primary ml-4 mt-2 w-75"
                            }
                            onClick={() => this.props.onCreateGrade(null, true)}
                          />
                        </p>
                      </Popup>
                    </WithPopup>
                  ) : null}

                  {this.props.isShowProductPopup ? (
                    <WithPopup>
                      <div></div>
                      <Popup
                        trigger="controlled"
                        position="bottom center"
                        disableDefaultStyle={true}
                        showCloseButton={true}
                        show={this.props.isShowProductPopup}
                        defaultOpen={false}
                        closeOnLostFocus={true}
                        onClose={() => this.props.onCloseProduct()}
                      >
                        <p>
                          <Input
                            inputAttributes={{ autoFocus: "true" }}
                            className={
                              this.props.productNameError
                                ? "error-code mt-2"
                                : "mt-2"
                            }
                            dataType="text"
                            label={t(
                              CONSTANTS.MODULE_PRODUCT +
                              " " +
                              CONSTANTS.LABLE_NAME
                            )}
                            placeholder={t(CONSTANTS.LABLE_NAME)}
                            required={true}
                            maxLength={250}
                            value={String(this.props.productName)}
                            onValueChange={(val: string) =>
                              this.props.setProductName(val)
                            }
                            showValidationBarWhenInvalid={
                              this.props.productNameError
                            }
                            description={
                              this.props.productNameError &&
                              t(CONSTANTS.INSTRUMENT_NAME_VALIDATION_ERROR)
                            }
                          />
                        </p>
                        <p>
                          <Input
                            className={
                              this.props.codeError ? "error-code mt-2" : "mt-2"
                            }
                            dataType="text"
                            label={t(CONSTANTS.LABEL_CODEID)}
                            placeholder={t(CONSTANTS.LABEL_CODEID)}
                            required={true}
                            maxLength={20}
                            value={String(this.props.inputCode)}
                            onValueChange={(val: string) =>
                              this.props.setCode(val)
                            }
                            showValidationBarWhenInvalid={this.props.codeError}
                            description={
                              this.props.codeError &&
                              t(CONSTANTS.INSTRUMENT_CODE_VALIDATION_ERROR)
                            }
                          />
                        </p>
                        <p>
                          <Button
                            disabled={this.props.isButtonDisabled}
                            type="primary-blue"
                            shape="rounded"
                            text={t(CONSTANTS.BUTTON_CREATE)}
                            icon={ICONCONSTANTS.ABB_PLUS}
                            className={
                              this.props.isButtonDisabled
                                ? "border ml-4 mt-2 w-75"
                                : "border border-primary ml-4 mt-2 w-75"
                            }
                            onClick={() =>
                              this.props.onCreateProduct(null, true)
                            }
                          />
                        </p>
                      </Popup>
                    </WithPopup>
                  ) : null}
                </div>
              </div>
            )}
            {this.props.isShowBackup ? (
              <div className="float-right">
                <Authorize scopes={[`${this.props.authKey}:Create`]}>
                  <Button
                    disabled={this.props.isButtonDisabled}
                    style={{ marginTop: "1px" }}
                    type="primary-black"
                    shape="pill"
                    onClick={() => this.props.onCreateBackup()}
                    text={
                      this.props.isCreatingBackup
                        ? t("Creating Backup Please Wait..")
                        : t(CONSTANTS.BUTTON_BACKUP)
                    }
                  />
                </Authorize>
              </div>
            ) : null}


            <Dialog
              isOpen={this.state.deleteModalVisible}
              // tslint:disable-next-line: jsx-no-lambda
              onClose={() => this.setState({ deleteModalVisible: false })}
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={t(CONSTANTS.DELETE_TITLE, {
                name: this.state.deleteTitle,
              })}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: (dlg) => dlg.close(),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: this.onDeleteClick,
                },
              ]}
            >
              <div className="delete-popup-text-overflow-hidden">
                {t(CONSTANTS.DELETE_MESSAGE, {
                  name: this.state.deleteMessage,
                  module: t(this.state.moduleName),
                })}
                <br />
                <br />
                <b>{t(CONSTANTS.NOTE)}:</b> {t(CONSTANTS.DELETE_POPUP_MESSAGE)}
              </div>
            </Dialog>
            <div className="clearfix" />
          </div>
        )}
      </Translation>
    );
  }
}
